import $axios from "../api/accessor";
import { $api } from "../api/api";

export const TariffsService = {
  async getAllTariffs() {
    let response = await $axios
      .get($api("tariffs"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
